import { render, staticRenderFns } from "./reportCommunitySpaceList.vue?vue&type=template&id=45d2940e&scoped=true"
import script from "./reportCommunitySpaceList.vue?vue&type=script&lang=js"
export * from "./reportCommunitySpaceList.vue?vue&type=script&lang=js"
import style0 from "./reportCommunitySpaceList.vue?vue&type=style&index=0&id=45d2940e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d2940e",
  null
  
)

export default component.exports